import { Box } from "@mui/material";
import BAButton from "../config/components/BAButton";
import BAScreenHeader from "../config/components/BAScreenHeader";
import html2canvas from "html2canvas";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import StarIcon from '@mui/icons-material/Star';
import PersonIcon from '@mui/icons-material/Person';
import feedback_mobile from "../assets/feedback_mobile.png";
import review_back from "../assets/review_back.png";
import review_background from "../assets/review_background.jpg";


function PrintFeedback(props) {
    const [model, setModel] = useState({})

    const location = useLocation()
    const imageRef = useRef(null);
    const [ratings, setRatings] = useState([1, 2, 3, 4, 5])

    const generateImage = async () => {
        if (imageRef.current) {
            const canvas = await html2canvas(imageRef.current);
            const imageSrc = canvas.toDataURL("image/png");
            shareImage(imageSrc);
        }
    };

    const shareImage = (imageSrc) => {
        const link = document.createElement("a");
        link.href = imageSrc;
        link.download = "Feedback_Post";
        link.click();
    };



    useEffect(() => {
        setModel({ ...location.state.model })


    }, []);

    return (
        <div className="bg-transparent">
            <BAScreenHeader
                title="Print Feedback Post"
                buttonsList={[

                    {
                        displayField: (
                            <BAButton
                                onClick={generateImage}
                                label="print"
                            />
                        ),
                    },
                ]}
            />
            <div
                style={{ position: "relative", width: "fit-content", margin: "auto" }}
            >
                <div ref={imageRef}>
                    <div
                        style={{
                            height: "100%",
                            minWidth: "500px",
                            // backgroundColor: '#ffffff'
                            // backgroundImage: `url(${review_background})`,
                            // background: 'radial-gradient(#DED9D1, #C5BFB3)'
                            // backgroundImage: `url(${post_back})`,
                            // backgroundPosition: 'center',
                            // backgroundSize: 'cover',
                        }}
                        className="border"
                    >
                        {/* <img style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            zIndex: 1,
                            width: '100%',
                            height: '100%',
                        }} src={post_back} alt="" /> */}
                        <div style={{ height: '100%', position: 'relative', zIndex: 2, display: 'flex' }} className="p-2">

                            <Box className="d-flex flex-column justify-content-center p-2" sx={{ width: 265 }}>
                                <p style={{ color: '#538B1D' }} className="m-0 fw-bold">What they Says</p>
                                <p style={{ lineHeight: '25px' }} className="fs-3 fw-bold m-0 p-0">What Our Client Says</p>
                                <Box className="mt-4">
                                    <p style={{ color: '#538B1D' }} className="fs-4 m-0 fw-bold">{model.customerName}</p>
                                    <p className="m-0 p-0"> {ratings.map((x, i) => <span key={i} className={x <= model.starRating ? "text-warning" : "text-muted"}><StarIcon /></span>)}</p>
                                    <p className="m-0"><q>{model.comments}</q></p>
                                </Box>
                            </Box>
                            <Box sx={{ width: 200 }} className="p-2 d-flex align-items-center">
                                <img src={feedback_mobile} width={200} alt="" />
                            </Box>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrintFeedback;
